module.exports = __webpack_public_path__ + "img/tutorial-11.47fa2505.svg";